import CoverageLimitExceededCard from "components/card/coverage-limit-exceeded/CoverageLimitExceeded";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { useMarkApplicationSubmitted } from "hooks";

const CoverageLimitExceededPage = () => {
    useMarkApplicationSubmitted();

    return (
        <>
            <title>Coverage Limit Exceeded | AAA Life</title>
            <ApplicationContainer useTitle={false} data-testid="coverage-limit-exceeded-page">
                <CoverageLimitExceededCard />
            </ApplicationContainer>
        </>
    );
};

export default CoverageLimitExceededPage;
